import { Button } from 'component/Button'
import { Loader } from 'component/Loader'
import { Typo } from 'component/Typo'
import { useTryOn } from 'hook/useTryOn'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Item } from 'type/Item'

type Props = {
  item: Item
  outline?: boolean
  primary?: boolean
  className?: string
}

export const TryButton = observer(({ item, outline, primary, className }: Props) => {
  const { item_id } = item
  const { loading, onTry } = useTryOn({ itemId: item_id })

  return <Button className={className} xl text outline={outline}
    invert={primary} compact action={onTry} disabled={loading}>
    {loading ? <Loader /> : <Typo ellipsis line={16}>
      {i18n('demo.TryOn')}
    </Typo>}
  </Button>
})
